document.addEventListener('change', (event) => {
  const select = event.target.closest('.quick-add__variant-select');
  if (!select) return;

  const productForm = select.closest('product-form');
  if (!productForm || typeof productForm.toggleSubmitButton !== 'function') return;

  const selectedOption = select.options[select.selectedIndex];
  const available = selectedOption.dataset.available === 'true';

  productForm.toggleSubmitButton(!available, available ? undefined : window.variantStrings.soldOut);
});
